module.exports = __webpack_public_path__ + "img/app-icon.514ff9b0.jpg";